import './Footer.css';
import { getTranslatedText as translate } from '../Localization/Translation';
import { useSelector } from 'react-redux';
import { useBetween } from 'use-between';
import { NavLink, Route, Routes } from 'react-router-dom';

function Footer() {
    const { locale } = useBetween(useSelector(state => state.useSharedLang));

    return (
        <div className="Footer">
            <div className='copy-rights-section current-section-start' >
                <div className='copy-rights'>
                    <div>
                        {translate('copy-rights-start-1', locale)}
                        <NavLink to='/ContactUs' className="nav-link-navbar" >
                            <span className='contact'>{translate('copy-rights-start-2', locale)}</span>
                        </NavLink>
                    </div>

                    <div>
                        <span>&copy; {translate('copy-rights-start-3', locale)} </span>
                        <span>{translate('copy-rights-start-4', locale)}</span>
                    </div>

                    <div>
                        <span>{translate('copy-rights-start-5', locale)}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;
